import { reportingRoutes } from 'src/features/reporting/routes';
import { TemplatesContainer } from 'src/features/templates/container';
import { bulkRoutes } from '../features/bulk/routes';
import { reportRoutes } from '../features/report/routes';
import { holdingsRoutes } from '../features/holdings/routes';
import { modelRoutes } from '../features/models/modelRoutes';
import { clientRoutes } from '../features/clients/clientRoutes';
import { strategyRoutes } from '../features/strategy/strategyRoutes';
import { rebalanceRoutes } from '../features/orders/rebalance/routes';
import { workflowRoutes } from '../features/workflows/workflowRoutes';
import { securityRoutes } from '../features/securities/securityRoutes';
import { forexRateRoutes } from '../features/forexrates/forexrateRoutes';
import { expiringTermDepositRoutes } from 'src/features/expiringTermDeposits/expiringTermDepositsRoutes';

const routes = [
  ...clientRoutes,
  ...rebalanceRoutes,
  ...bulkRoutes,
  ...holdingsRoutes,
  ...modelRoutes,
  ...securityRoutes,
  ...reportRoutes,
  ...strategyRoutes,
  ...workflowRoutes,
  ...forexRateRoutes,
  ...expiringTermDepositRoutes,
  ...reportingRoutes,
  {
    path: '/templates',
    component: TemplatesContainer,
    protected: true,
    exact: false,
  },
];

export default routes;
